import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { get } from '../utils/api'

const Certificate = () => {
  const [imageUrl, setImageUrl] = useState(null)

  const { id } = useParams()

  const getCertificateUrl = async () => {
    if (id !== undefined && id !== null && typeof id === 'string') {
      const result = await get(`/api/certificates/${id}`)

      const url = result?.url
      setImageUrl(url)
    }
  }

  useEffect(() => {
    getCertificateUrl()
  }, [])

  return (
    <div className="flex w-full h-full justify-center items-center">
      {imageUrl && (
        <img
          src={imageUrl}
          alt="Certificate URL"
          className="w-full h-screen object-contain"
        />
      )}
    </div>
  )
}

export default Certificate
